'use client';

import type { LiHTMLAttributes, ReactNode } from 'react';
import styled from 'styled-components';

import type { SpacingType } from '@zoomit/primitives';
import { Col, spacingHelper } from '@zoomit/primitives';

type ListItemProps = {
  spacing?: SpacingType;
  indicator?: ReactNode;
};

const ListItemBase = styled.li<ListItemProps>`
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  ${({ spacing }) => spacing && spacingHelper(spacing)};
`;

type Props = LiHTMLAttributes<HTMLLIElement> & ListItemProps;

export const ListItem = (props: Props) => {
  const { spacing, indicator, children, ...rest } = props;

  return (
    <ListItemBase indicator={indicator} spacing={spacing} {...rest}>
      {indicator && (
        <Col size={0.25} style={{ marginTop: '8px' }}>
          {indicator}
        </Col>
      )}
      <Col>{children}</Col>
    </ListItemBase>
  );
};
